'use strict';

// ==========================================================================
// Slider Set Royal Slider JS Module
// ==========================================================================


define(['jquery'], function () {

  // Global
  // ==========================================================================
  var rsInstance = []; // For royal slider plus AMD

  //detect touch devices - change the slider parameters for touch enabled devices.

  var $sliderDrag, $sliderTouch, $transitionType, $fadeinLoadedSlide;

  if ('ontouchstart' in document.documentElement) {
    $sliderDrag = 'true';
    $sliderTouch = 'true';
    $transitionType = 'move';
    $fadeinLoadedSlide = true;
  } else {
    $sliderDrag = 'false';
    $sliderTouch = 'false';
    $transitionType = 'move';
    $fadeinLoadedSlide = false;
  }

  var $sliderSet = $('.slider-set .royal-slider');

  if ($('.royal-slider').children().length > 1) {
    $sliderSet.each(function (i) {
      var rs = $(this).royalSlider({
        sliderDrag: $sliderDrag,
        sliderTouch: $sliderTouch,
        transitionType: $transitionType,
        arrowsNav: true,
        controlNavigation: 'bullets',
        controlsInside: false,
        arrowsNavAutoHide: false,
        allowCSS3: false,
        loop: true,
        loopRewind: true,
        numImagesToPreload: 3,
        //transitionType: 'fade',
        keyboardNavEnabled: true,
        slidesSpacing: 0,
        fadeinLoadedSlide: $fadeinLoadedSlide,
        autoPlay: {
          //autoplay options go here
          enabled: true,
          pauseOnHover: true,
          delay: 6000
        }
      });

      rsInstance[i] = {
        'find': $(this),
        'data': rs.data('royalSlider')
      };
    });
  }

  $sliderSet.find('.btn[data-href]').click(function () {
    window.location = $(this).attr('data-href');
    return false;
  });

  return rsInstance;
});
//# sourceMappingURL=slider-set.js.map
